package one.healthium.ui.components.question

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastForEach
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black_8
import one.healthium.ui.compose.theme.gray_7

@Composable
fun QuestionItem(
    modifier: Modifier = Modifier,
    uiModel: QuestionUiModel,
    onAnswerSelected: (AnswerUiModel) -> Unit,
) {
    Column(modifier = modifier) {
        if (!uiModel.kind.isNullOrEmpty()) {
            Text(
                text = uiModel.kind,
                style = AppTheme.textStyles.secondary_16_700,
                color = AppTheme.colors.text400,
            )
        }
        if (uiModel.question != null && uiModel.question.isNotEmpty()) {
            Spacer(Modifier.height(4.dp))
            Text(
                text = uiModel.question,
                style = AppTheme.textStyles.secondary_16_500,
                color = AppTheme.colors.text400,
                fontStyle = FontStyle.Italic,
            )
        }
        Spacer(Modifier.height(12.dp))
        FlowRow(
            modifier = Modifier
                .fillMaxWidth()
                .background(
                    color = gray_7,
                    shape = AppTheme.shapes.small,
                )
                .padding(horizontal = 12.dp, vertical = 24.dp),
            horizontalArrangement = Arrangement.spacedBy(12.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            uiModel.answers.fastForEach { option ->
                Box(
                    modifier = Modifier
                        .clip(RoundedCornerShape(6.dp))
                        .clickable { onAnswerSelected(option) }
                        .background(
                            color = when (option.status) {
                                AnswerStatus.Included -> AppTheme.colors.primary
                                AnswerStatus.Excluded -> black_8
                                AnswerStatus.None -> AppTheme.colors.surface
                            },
                        )
                        .defaultMinSize(minHeight = 34.dp)
                        .padding(horizontal = 12.dp, vertical = 6.dp),
                    contentAlignment = Alignment.Center,
                ) {
                    Text(
                        text = option.displayValue,
                        style = AppTheme.textStyles.secondary_14_500,
                        color = if (option.selected) {
                            AppTheme.colors.onPrimary
                        } else {
                            AppTheme.colors.onSurface
                        }
                    )
                }
            }
        }
    }
}

@Composable
@Preview(showBackground = true)
private fun HealthLogQuestionItemPreview() {
    AppTheme {
        Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
            QuestionItem(
                uiModel = QuestionUiModel(
                    id = "test",
                    kind = null,
                    question = "Did you feel energized?",
                    allowedStatuses = listOf(),
                    answers = listOf(
                        AnswerUiModel(
                            id = "test",
                            text = "Avocado",
                            status = AnswerStatus.Excluded,
                        ),
                        AnswerUiModel(
                            id = "test",
                            text = "Milk",
                            status = AnswerStatus.Included,
                        ),
                        AnswerUiModel(
                            id = "test",
                            text = "Egg",
                            status = AnswerStatus.None,
                        )
                    )
                ),
                onAnswerSelected = {},
            )
        }
    }
}